var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

var Loading = function (_React$Component) {
  _inherits(Loading, _React$Component);

  function Loading() {
    _classCallCheck(this, Loading);

    return _possibleConstructorReturn(this, (Loading.__proto__ || Object.getPrototypeOf(Loading)).apply(this, arguments));
  }

  _createClass(Loading, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          active = _props.active,
          className = _props.className,
          withOverlay = _props.withOverlay,
          small = _props.small,
          other = _objectWithoutProperties(_props, ['active', 'className', 'withOverlay', 'small']);

      var loadingClasses = classNames('bx--loading', className, {
        'bx--loading--small': small,
        'bx--loading--stop': !active
      });

      var loading = React.createElement(
        'div',
        _extends({}, other, { className: loadingClasses }),
        React.createElement(
          'svg',
          { className: 'bx--loading__svg', viewBox: '-75 -75 150 150' },
          React.createElement('circle', { cx: '0', cy: '0', r: '37.5' })
        )
      );

      return withOverlay ? React.createElement(
        'div',
        { className: 'bx--loading-overlay' },
        loading
      ) : loading;
    }
  }]);

  return Loading;
}(React.Component);

Loading.propTypes = {
  active: PropTypes.bool,
  className: PropTypes.string,
  withOverlay: PropTypes.bool,
  small: PropTypes.bool
};
Loading.defaultProps = {
  active: true,
  withOverlay: true,
  small: false
};
export default Loading;


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/components/Loading/Loading.js
// module id = 338
// module chunks = 0